<template>
    <div>
        <section class="section--alt has-bottom-image">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div class="block">
                            <div class="row">
                                <img
                                    class="icon--simtoool col-4"
                                    src="../assets/images/icon_simtool.png"
                                />
                                <div class="col-8">
                                    <h1>{{ $t('account.passwordforget.title') }}</h1>
                                    <p v-if="flow === FLOW_REQUEST">
                                        {{ $t('account.passwordforget.sub_title') }}
                                    </p>
                                    <p v-else-if="flow === FLOW_CONFIRM">
                                        {{ $t('account.passwordforget.confirm.sub_title') }}
                                    </p>
                                </div>
                            </div>
                            <form
                                v-if="flow === FLOW_REQUEST"
                                class="form--rounded"
                                @submit.prevent="submitRequest"
                            >
                                <form-input
                                    v-model="form"
                                    name="email"
                                    :placeholder="$t('account.form.email')"
                                />
                                <input
                                    type="submit"
                                    class="button--primary button--rounded is-full-width"
                                    :disabled="loading"
                                    :value="$t('account.passwordforget.button')"
                                />
                                <p v-show="success" class="form__success">
                                    {{ $t('account.passwordforget.succes') }}
                                </p>
                                <p v-show="error" class="form__error">
                                    {{ $t('account.passwordforget.error') }}
                                </p>
                            </form>
                            <form
                                v-else-if="flow === FLOW_CONFIRM"
                                class="form--rounded"
                                @submit.prevent="submitConfirm"
                            >
                                <form-input
                                    v-model="form"
                                    name="password"
                                    type="password"
                                    :placeholder="$t('account.form.password')"
                                />
                                <form-input
                                    v-model="form"
                                    name="password_confirm"
                                    type="password"
                                    :placeholder="$t('account.form.confirm_password')"
                                />
                                <input
                                    id="simtool_reset_password"
                                    type="submit"
                                    class="button--primary button--rounded is-full-width"
                                    :disabled="loading"
                                    :value="$t('account.passwordforget.button')"
                                />
                                <p v-show="success" class="form__success">
                                    {{ $t('account.passwordforget.confirm.success') }}
                                </p>
                                <p v-show="error" class="form__error">
                                    {{ $t('account.passwordforget.confirm.error') }}
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <img class="section__bottom_image" src="./../assets/images/tecnotion.png" />
        </section>
        <EndSignUpMail />
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import FormInput from '@/components/FormInput';
import EndSignUpMail from '@/components/EndSignUpMail';

@Component({
    components: {
        FormInput,
        EndSignUpMail,
    },
})
export default class PasswordReset extends Vue {
    FLOW_REQUEST = 'request';
    FLOW_CONFIRM = 'confirm';

    flow = null;
    loading = false;
    success = false;
    error = false;

    form = {
        email: { value: null, error: '' },
        password: { value: null, error: '' },
        password_confirm: { value: null, error: '' },
    };

    // eslint-disable-next-line no-useless-escape
    emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    passwordPattern = /^.{8,}$/;

    created() {
        if (this.$route.query.token && this.$route.query.email) {
            this.flow = this.FLOW_CONFIRM;
        } else {
            this.flow = this.FLOW_REQUEST;
        }
    }

    async submitRequest() {
        if (this.loading) return;

        this.resetForm();

        if (!this.form.email.value || !this.emailPattern.test(this.form.email.value)) {
            Vue.set(this.form.email, 'error', this.$i18n.t('account.errors.not_valid_email'));
            return;
        }

        try {
            this.loading = true;

            const request = Vue.api.post('/reset-password');
            request.json = false;
            await request.send(
                JSON.stringify({
                    email: this.form.email.value,
                }),
            );

            this.success = true;
        } catch (e) {
            this.error = true;
        } finally {
            this.loading = false;
        }
    }

    async submitConfirm() {
        if (this.loading) return;

        this.resetForm();

        if (!this.form.password.value) {
            Vue.set(this.form.password, 'error', this.$i18n.t('account.errors.not_filled'));
        } else if (!this.passwordPattern.test(this.form.password.value)) {
            Vue.set(this.form.password, 'error', this.$i18n.t('account.errors.not_long_password'));
        }

        if (!this.form.password_confirm.value) {
            Vue.set(this.form.password_confirm, 'error', this.$i18n.t('account.errors.not_filled'));
        } else if (this.form.password.value !== this.form.password_confirm.value) {
            Vue.set(
                this.form.password_confirm,
                'error',
                this.$i18n.t('account.errors.not_matching_passwords'),
            );
        }

        if (Object.keys(this.form).some(k => !!this.form[k].error)) {
            return;
        }

        try {
            this.loading = true;

            const request = Vue.api.post('/reset-password');
            request.json = false;
            await request.send(
                JSON.stringify({
                    email: this.$route.query.email,
                    token: this.$route.query.token,
                    password: this.form.password.value,
                    password_confirm: this.form.password_confirm.value,
                }),
            );

            this.success = true;

            setTimeout(() => {
                this.$router.push({
                    name: 'Login',
                });
            }, 5000);
        } catch (e) {
            this.error = true;
        } finally {
            this.loading = false;
        }
    }

    resetForm() {
        this.error = false;
        this.success = false;
        this.form = {
            email: { value: this.form.email.value, error: '' },
            password: { value: this.form.password.value, error: '' },
            password_confirm: { value: this.form.password_confirm.value, error: '' },
        };
    }
}
</script>
